import React, { useState } from "react";
import styled from "styled-components";

const TinyNoteDiv = styled.div`
font-size:70%;
line-height:1.1em;
`;


// eslint-disable-next-line no-unused-vars
export const VideoAlphaWarning = props => {
    const [visible, setVisible] = useState(true);

    if (!visible) { return null; }

    return (
        <TinyNoteDiv onClick={()=>{setVisible(false);}}>
            Heads up: Video-chat mode is even <i>more</i> experimental. It also costs me money, so it may stop working at any time 
            if the Twilio account runs out of credit. Click and hold on the microphone button to speak. You really should have headphones on for this. <a href="#hide" onClick={()=>{setVisible(false);}}>[close]</a>
        </TinyNoteDiv>
    );
};
